import React from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterRoleAdd = ({ buttonConfig, isButtonClicked }) => {
  const addHandler = buttonConfig.addHandler;

  const closeHandler = buttonConfig.closeAddModal;

  const schema = z.object({
    name: z.string().nonempty(),
    short_name: z.string(),
    dep_code: z.string().nonempty(),
    status: z.string(),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      short_name: "-",
      eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;
  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };
    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  console.log(form.getValues("eff_start_date"));

  const validateEndDate = (value) => {
    const startDate = form.getValues("eff_start_date");
    if (!value) {
      return "End date is required";
    } else if (value <= startDate) {
      return;
    }

    return true;
  };

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-sm:top-[10%] sm:top-1/2 sm:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">Add Demat</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          {/* row 1 */}
          <div className="gap-2 sm:flex max-sm:[&>div]:mt-4">
            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Demat Name *</label>
              <input
                placeholder="Type here"
                {...form.register("name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.name && "border-[1px] border-red-300",
                )}
              />
            </div>

            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Short Name</label>
              <input
                placeholder="Type here"
                {...form.register("short_name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.short_name && "border-[1px] border-red-300",
                )}
              />
            </div>

            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">
                Depository Code *
              </label>
              <input
                placeholder="Type here"
                {...form.register("dep_code")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.dep_code && "border-[1px] border-red-300",
                )}
              />
            </div>
          </div>

          {/* row 2 */}

          <div className="items-end gap-2 sm:flex ">
            <div className="flex h-full w-full  flex-col gap-2 max-sm:mt-4">
              <label className="text-[#636363]">Status</label>
              <div
                className={cn(
                  " h-full rounded bg-neutral-100 px-2 py-[9px]",
                  errors.status && "border-[1px] border-red-300",
                )}
              >
                <select
                  {...form.register("status")}
                  className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                  defaultValue={true}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            </div>

            <div className="flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4 sm:mt-8">
              <div className="flex w-full  flex-col gap-2 ">
                <label>Start date *</label>

                <div className="relative flex w-full">
                  {/* <input
                    type="date"
                    {...form.register("eff_start_date")}
                    className={cn(
                      "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                      errors.eff_start_date && "border-[1px] border-red-300",
                    )}
                  />
                  <img
                    src={datePickerIcon}
                    className="absolute right-1 top-1/2 w-[20px] -translate-y-1/2"
                  /> */}

                  <CustomDateInput
                    form1={form.register("eff_start_date")}
                    className={"w-full py-[0.7rem]"}
                  />
                </div>
              </div>
            </div>

            <div className="w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4 sm:mt-8 sm:flex">
              <div className="flex w-full  flex-col gap-2 ">
                <label>End date</label>

                <div className="relative flex w-full">
                  {/* <input
                    type="date"
                    {...form.register("eff_end_date", {
                      validate: validateEndDate,
                    })}
                    min={form.getValues("eff_start_date")}
                    className={cn(
                      "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                      errors.eff_end_date && "border-[1px] border-red-300",
                    )}
                  />

                  <img
                    src={datePickerIcon}
                    className="absolute right-1 top-1/2 w-[20px] -translate-y-1/2"
                  /> */}
                  <CustomDateInput
                    form1={form.register("eff_end_date", {
                      validate: validateEndDate,
                    })}
                    min={form.getValues("eff_start_date")}
                    className={"w-full py-[0.7rem]"}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-end justify-between gap-2 sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
          </div>
        </form>
      </div>
      <BackDrop
      //  closeHandler={closeHandler}
      />
    </>
  );
};

export default MasterRoleAdd;
